document.addEventListener("alpine:init", () => {
  const MATAAccordion = (config = {}) => ({
    isOpen: Boolean(config.startOpen),
    toggle(triggerEl) {
      const current = triggerEl ? triggerEl.closest(".mata-accordion") : null;
      const wrapper = triggerEl
        ? triggerEl.closest("[data-mata-accordion-wrapper]")
        : null;

      if (wrapper && current && window.Alpine) {
        wrapper.querySelectorAll(".mata-accordion").forEach((accordion) => {
          if (accordion === current) return;
          if (accordion.contains(current) || current.contains(accordion))
            return;

          const data = Alpine.$data(accordion);
          if (data && typeof data.isOpen !== "undefined") data.isOpen = false;
        });
      }

      this.isOpen = !this.isOpen;
    },
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
  });

  window.MATAAccordion = MATAAccordion;
  Alpine.data("MATAAccordion", MATAAccordion);
});